"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.Space, null, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: "primary"
  }, "Primary Button"), /*#__PURE__*/_react.default.createElement(_antd.Button, null, "Default Button"), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: "dashed"
  }, "Dashed Button"), " ", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: "text"
  }, "Text Button"), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    ghost: true
  }, "Ghost Button"), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: "link"
  }, "Link Button"));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorText', 'colorPrimary', 'colorPrimaryActive', 'colorPrimaryHover', 'controlOutline', 'controlTmpOutline'],
  key: 'button'
};
var _default = exports.default = componentDemo;